<template>
    <span
        class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800">
        {{ item.name }}
    </span>
</template>

<script>
export default {
    name: "DeskItem",

    props: ['item'],
}
</script>

<style scoped>

</style>
